import { localStorage } from '@fiverr-private/futile';

const STORAGE_PREFIX = 'fiverr_education_tooltips';

const get = (tooltipKey) => localStorage.get(storageKey(tooltipKey));

const set = (tooltipKey, value) => {
    localStorage.set(storageKey(tooltipKey), value);
};

export const isSeen = (tooltipKey) => {
    if (!tooltipKey) {
        return false;
    }

    return get(tooltipKey) === 'true';
};

const storageKey = (tooltipKey) => `${STORAGE_PREFIX}.${tooltipKey}`;

export const setSeen = (tooltipKey?: string) => {
    if (!tooltipKey) {
        return;
    }

    set(tooltipKey, 'true');
};
